import React, { memo } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'react-final-form';

import { AppState } from 'services/types';
import RenderDropdown from 'forms/RenderDropdown';
import { isRequired } from 'forms/validators';
import { selectColumnsAsDropdownOptions } from 'services/virtualizedTable/selectors';

export interface ConnectedProps {
    columnsAsDropdownOptions: ReturnType<typeof selectColumnsAsDropdownOptions>;
}

export type Props = ConnectedProps;

export const VirtualizedTableBulkEditFormColumnDropdownComponent = (
    props: Props
): React.ReactElement => {
    const { columnsAsDropdownOptions } = props;
    return (
        <Field
            name="columnKey"
            label="Field"
            options={columnsAsDropdownOptions}
            component={RenderDropdown as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            placeholder="Add Field"
            fluid
            search
            selection
            selectOnBlur={false}
            validate={isRequired}
        />
    );
};

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    columnsAsDropdownOptions: selectColumnsAsDropdownOptions
});

export default connect(mapStateToProps)(
    memo(VirtualizedTableBulkEditFormColumnDropdownComponent)
);
